<template>
  <div class="footer">
    <div
      class="button"
      @click="selectMenu(0)"
      :class="index == 0 ? 'button-active' : ''"
    >
      <!-- <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 0" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 0"
      /> -->
      <div>公司简介</div>
    </div>
    <div
      class="button"
      @click="selectMenu(4)"
      :class="index == 4 ? 'button-active' : ''"
    >
      <!-- <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 4" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 4"
      /> -->
      <div>双 碳</div>
    </div>
    <el-popover
      placement="top"
      width="200"
      trigger="click"
      v-model="showPopover"
    >
      <div class="button-footer">
        <div class="button" @click="selectMenu(1)">
          <!-- <img src="@/assets/images/companyinfo.png" alt="" /> -->

          <div>汽 废</div>
        </div>
        <div class="button" @click="selectMenu(2)">
          <!-- <img src="@/assets/images/companyinfo.png" alt="" /> -->
          <div>电 废</div>
        </div>
        <div class="button" @click="selectMenu(3)">
          <!-- <img src="@/assets/images/companyinfo.png" alt="" /> -->
          <div>医 废</div>
        </div>
      </div>

      <div
        class="button"
        slot="reference"
        :class="index == 1 || index == 2 || index == 3 ? 'button-active' : ''"
      >
        <!-- <img
          src="@/assets/images/companyinfo.png"
          alt=""
          v-if="index == 0 || index == 4 || index == -1"
        />
        <img
          src="@/assets/images/companyinfo-active.png"
          alt=""
          v-if="index == 1 || index == 2|| index == 3"
        /> -->
        <div>业 务</div>
      </div>
    </el-popover>
  </div>
</template>
  
  <script>
export default {
  props: ["index"],
  data() {
    return {
      showPopover: false,
      nowTime: "",
      type: "index",
      gridData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
      ],
    };
  },

  methods: {
    selectMenu(index) {
      this.showPopover = false;
      this.$emit("selectMenu", index);
    },
  },
};
</script>
  <style>
  .button-footer{
    /* margin: 0 auto !important; */
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
.button-footer .button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("~@/assets/botton.png") no-repeat center;
  background-size: 100% 100%;
  width: 200px;
  padding: 10px 0;
  color: #fff;
  /*  */
  cursor: pointer;
  height: 30px;
  margin: 5px;
}
.button-footer .button img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
.el-popover {
  background: unset;
  padding: unset;
  border: unset;
  border-radius: unset;
}
</style>
